import { AxiosInstance, AxiosResponse } from "axios";
import { fetcher } from "../../configurations";
import {
    Repair,
    RepairFilters,
    RepairMeta
} from "../../interfaces";

export class RepairRepository {
    private lmBootApi: AxiosInstance;

    constructor() {
        this.lmBootApi = fetcher(process.env.REACT_APP_URL_API_2 as string);
    }

    createRepair(data: { orderId: string, measurementsId: string, email: string, price: number }): Promise<AxiosResponse<{ message: string }>> {
        console.log(data);
        return this.lmBootApi.post<{ message: string }>("/repairs", data);
    }

    getRepairs(filters: RepairFilters): Promise<AxiosResponse<{ data: Repair[], meta: RepairMeta }>> {
        return this.lmBootApi.get<{ data: Repair[], meta: RepairMeta }>("/repairs", { params: filters });
    }

    getRepairById(repairId: string): Promise<AxiosResponse<Repair>> {
        return this.lmBootApi.get<Repair>(`/repairs/${repairId}`);
    }

    updateRepairStatus(repairId: string, location?: string): Promise<AxiosResponse<{ message: string }>> {
        return this.lmBootApi.put<{ message: string }>(`/repairs/${repairId}/status`, { location });
    }

    addRepairNote(repairId: string, note: string): Promise<AxiosResponse<{ message: string }>> {
        console.log('note: ', note, 'repairId: ', repairId);
        return this.lmBootApi.post<{ message: string }>(`/repairs/${repairId}/notes`, { note });
    }

    associateRepairFiles(repairId: string, formData: any): Promise<AxiosResponse<{ message: string }>> {
        return this.lmBootApi.post<{ message: string }>(`/repairs/${repairId}/files`, formData, {headers: { "Content-Type": "multipart/form-data" }});
    }

    generateRepToWellingtonLabel(repairId: string): Promise<AxiosResponse<{ message: string }>> {
        return this.lmBootApi.post<{ message: string }>(`/repairs/${repairId}/labels/rep-to-wellington`);
    }

    generateCustomerToWellingtonLabel(repairId: string): Promise<AxiosResponse<{ message: string }>> {
        return this.lmBootApi.post<{ message: string }>(`/repairs/${repairId}/labels/customer-to-wellington`);
    }
}

